import Pusher from 'pusher-js'

import { config } from '../config'
import { ID_TOKEN } from '../utils/auth/auth.const'

const AUTH_ENDPOINT = `${config.apiUrl}/pusher/auth`
const PUSHER_KEY = config.pusher_key
const ENV = config.env

export default class PusherService {
  /**
   * Constructor
   */
  constructor ({ userId, token }) {
    _setLogging()
    this.pusher = new Pusher(PUSHER_KEY, {
      authEndpoint: AUTH_ENDPOINT,
      auth: {
        headers: { Authorization: 'Bearer ' + _getToken() }
      }
    })
    this.channelName = `private-contactadmin-${ENV}-${userId}`
    this.subscribeToChannel(this.channelName)
  }

  /**
   * Subscribe to channel
   * @param channelName
   */
  subscribeToChannel (channelName) {
    this.channel = this.pusher.subscribe(channelName)
    return this.channel
  }

  /**
   * Subscribe to events for channel
   * @param {*} eventName
   * @param {*} callback
   */
  subscribeToEvent (eventName, callback) {
    this.channel.bind(eventName, callback)
  }
}

/**
 * Enable Logging
 */
const _setLogging = () => {
  const enableLogging = ['local'].includes(process.env.REACT_APP_ENV)
  Pusher.logToConsole = enableLogging
}

/**
 * Get Token
 */
const _getToken = () => {
  return localStorage.getItem(ID_TOKEN)
}
